import { renderSettingsResourceLabel } from "../../../../../../../utils/helpers/settings";
import { Label } from "../../../../../helpers/historyHelpers/components/Label";
import { NewValue } from "../../../../../helpers/historyHelpers/components/NewValue";
import { OldValue } from "../../../../../helpers/historyHelpers/components/OldValue";

export const renderItem = (value, label, t) => {
    const newValue = value?.new;
    const oldValue = value?.old;

    let content;

    if (typeof newValue === "boolean" || typeof oldValue === "boolean") {
        content = (
            <>
                {typeof oldValue === "boolean" && <OldValue value={oldValue ? t("active") : t("not-active")} />}

                <NewValue value={newValue ? t("active") : t("not-active")} />
            </>
        );
    } else if (Array.isArray(newValue) && newValue?.length > 0) {
        const newValueFormatted = (
            <div className="d-flex flex-column justify-content-start align-items-start">
                {newValue.map((item, i) => {
                    return <span key={i}>{t(item)}</span>;
                })}
            </div>
        );
        const oldValueFormatted = (
            <div className="d-flex flex-column justify-content-start align-items-start">
                {oldValue.map((item, i) => {
                    return <span key={i}>{t(item)}</span>;
                })}
            </div>
        );
        content = (
            <>
                {oldValue && <OldValue value={oldValueFormatted} />}

                <NewValue value={newValueFormatted} />
            </>
        );
    } else if (typeof newValue === "string" || typeof oldValue === "string") {
        content = (
            <>
                {oldValue && <OldValue value={oldValue} />}

                <NewValue value={newValue} />
            </>
        );
    } else {
        content = (
            <>
                {oldValue && <OldValue value={renderSettingsResourceLabel(oldValue)} />}

                <NewValue value={renderSettingsResourceLabel(newValue)} />
            </>
        );
    }

    return (
        <div className="d-flex align-items-center gap-2 mb-1 w-100">
            <Label value={t(label)} />
            {content}
        </div>
    );
};
